import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useReducer } from "react";
import { AuthContext, AuthDispatchContext, authReducer, EMPTY_AUTH_STATE, } from "./AuthContext";
import { CustomPrivyProvider } from "./providers/privy/CustomPrivyProvider";
export const AuthProvider = ({ children }) => {
    // if (isMiniApp) {
    //   return <FarcasterAuthProvider>{children}</FarcasterAuthProvider>;
    // }
    return _jsx(PrivyAuthProvider, { children: children });
};
export const PrivyAuthProvider = ({ children, }) => {
    const [auth, dispatch] = useReducer(authReducer, EMPTY_AUTH_STATE);
    return (_jsx(AuthContext.Provider, { value: auth, children: _jsx(AuthDispatchContext.Provider, { value: dispatch, children: _jsx(CustomPrivyProvider, { children: children }) }) }));
};
